import { render, staticRenderFns } from "./ivr-info.vue?vue&type=template&id=ae71e9cc"
import script from "./ivr-info.vue?vue&type=script&lang=js"
export * from "./ivr-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports